import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { OfferItem } from '@recruitee/http-types';

import { OfferScope } from '../../types';

@Injectable({
  providedIn: 'root',
})
export class OffersByCompanyHttpService {
  constructor(private httpApi: HttpApiService) {}

  public fetchOne$(
    id: string,
    scope = OfferScope.Active,
  ): Observable<{ offers: OfferItem[]; id: string }> {
    const url = `${this.httpApi.appConfig.apiUrl}c/${id}/offers?scope=${scope}`;

    return this.httpApi.get(url, undefined, { skipURLBuild: true }).pipe(
      map(response => ({
        offers: response.offers,
        id,
      })),
    );
  }
}
